import { deserialize } from 'deserialize-json-api'

export const all = {
  data: [
    {
      id: '1',
      type: 'dropdown_options',
      attributes: {
        id: 1,
        key: 'reasons_for_changing_status',
        value: [
          'Clinically Ineligible',
          'Declined Qflow',
          'Duplicate Account',
          'Medicaid',
          'No longer interested',
          'Out of network',
          'Out of service Area',
          'Outside HIV Care',
          'Patient not responsive',
          'Pharmacy Transferred to External',
          'Uninsured',
          'Violated Terms of Use',
        ],
      },
    },
    {
      id: '2',
      type: 'dropdown_options',
      attributes: {
        id: 2,
        key: 'no_longer_interested',
        value: [
          'Desires / requires injectable',
          'Local care provider',
          'Monogamous relationship',
          'Not sexually active',
          'Other telePrEP provider',
          'Patient dissatisfied',
        ],
      },
    },
    {
      id: '3',
      type: 'dropdown_options',
      attributes: {
        id: 3,
        key: 'incomplete_appt_reasons',
        value: ['Incomplete Visit', 'Ineligible', 'Patient Unavailable'],
      },
    },
    {
      id: '4',
      type: 'dropdown_options',
      attributes: {
        id: 4,
        key: 'technical_issues_reasons',
        value: [
          'On Demand - patient disconnected',
          'Patient will reschedule',
          'Seeks unavailable service',
          'Technical Issues',
          'Visit switched to PEP/PrEP visit',
          'Visit switched to STI Testing/PrEP visit',
        ],
      },
    },
    {
      id: '5',
      type: 'dropdown_options',
      attributes: {
        id: 5,
        key: 'provider_suffixes',
        value: ['AACRN', 'AAHIVS', 'APRN', 'Care Coord', 'CNM', 'DO', 'LHC-MA', 'MD', 'NP', 'PA', 'PA-C', 'RN'],
      },
    },
    {
      id: '6',
      type: 'dropdown_options',
      attributes: {
        id: 6,
        key: 'reasons_for_returning_incomplete_labs',
        value: [
          'Labs already resulted',
          'Labs in transit already',
          'Labs were returned to sender',
          'Other team member already reminded patient to send labs back',
          'Patient opted for in person labs/change in lab order',
          'Patient taking a PrEP break',
          'Pt communicated known delay in getting labs back',
          'Pt uploaded own labs',
          'Recently sent pt reminder',
          'Too soon to remind patient',
        ],
      },
    },
    {
      id: '8',
      type: 'dropdown_options',
      attributes: {
        id: 8,
        key: 'appointment_communication_types',
        value: ['CBO', 'Email', 'No Communication', 'Phone Call', 'Portal Message'],
      },
    },
    {
      id: '9',
      type: 'dropdown_options',
      attributes: {
        id: 9,
        key: 'ineligible_appt_reasons',
        value: ['Ineligible - Clinical Reason', 'Ineligible - Insurance Reason'],
      },
    },
    {
      id: '10',
      type: 'dropdown_options',
      attributes: {
        id: 10,
        key: 'provider_reassignment_reasons',
        value: [
          'Address change',
          'Clinical lead requested',
          'Establishing HIV care',
          'Establishing PrEP care',
          'Medicaid provider needed',
          'Panel reassignment',
          'Patient inactivated prematurely',
          'Patient requested',
          'Provider assignment correction',
          'Provider requested',
          'Restarting care',
        ],
      },
    },
    {
      id: '11',
      type: 'dropdown_options',
      attributes: {
        id: 11,
        key: 'sti_testing_technical_issues_reasons',
        value: [
          'Incomplete visit- Already in PrEP Care. Wanting Out of Cycle Testing',
          'Incomplete visit- Uninsured',
          'Incomplete visit- Wanting Herpes Testing',
          'Incomplete visit- Wanting STI Treatment',
        ],
      },
    },
    {
      id: '12',
      type: 'dropdown_options',
      attributes: {
        id: 12,
        key: 'async_technical_issues_reasons',
        value: ['Invalid id', 'Patient no longer responsive', 'Patient uninsured'],
      },
    },
    {
      id: '13',
      type: 'dropdown_options',
      attributes: {
        id: 13,
        key: 'patient_genders',
        value: [
          {
            key: 'Male',
            label: 'Male',
          },
          {
            key: 'Female',
            label: 'Female',
          },
          {
            key: 'Intersex',
            label: 'Intersex',
          },
          {
            key: 'Transgender Male',
            label: 'Transgender Male',
          },
          {
            key: 'Transgender Female',
            label: 'Transgender Female',
          },
          {
            key: 'Gender Queer',
            label: 'Gender Queer',
          },
          {
            key: 'Nonconforming',
            label: 'Nonconforming',
          },
        ],
      },
    },
    {
      id: '14',
      type: 'dropdown_options',
      attributes: {
        id: 14,
        key: 'patient_pronouns',
        value: [
          {
            key: 'He/Him',
            label: 'He/Him',
          },
          {
            key: 'She/Her',
            label: 'She/Her',
          },
          {
            key: 'They/Them',
            label: 'They/Them',
          },
        ],
      },
    },
    {
      id: '15',
      type: 'dropdown_options',
      attributes: {
        id: 15,
        key: 'patient_ethnicities',
        value: [
          {
            key: 'Hispanic/Latino',
            label: 'Hispanic or Latino',
          },
          {
            key: 'Not Hispanic/Latino',
            label: 'Not Hispanic or Latino',
          },
          {
            key: 'No Answer',
            label: 'Prefer not to answer',
          },
        ],
      },
    },
    {
      id: '16',
      type: 'dropdown_options',
      attributes: {
        id: 16,
        key: 'patient_relationships',
        value: [
          {
            key: 'Committed Relationship',
            label: 'Committed Relationship',
          },
          {
            key: 'Open Relationship',
            label: 'Open Relationship',
          },
          {
            key: 'Single',
            label: 'Single',
          },
        ],
      },
    },
    {
      id: '17',
      type: 'dropdown_options',
      attributes: {
        id: 17,
        key: 'patient_races',
        value: [
          {
            key: 'African American / Black',
            label: 'African American / Black',
          },
          {
            key: 'Asian',
            label: 'Asian',
          },
          {
            key: 'Caucasian/White',
            label: 'Caucasian/White',
          },
          {
            key: 'Native American or Alaska Native',
            label: 'Native American or Alaska Native',
          },
          {
            key: 'Native Hawaiian or Pacific Islander',
            label: 'Native Hawaiian or Pacific Islander',
          },
          {
            key: 'Prefer not to answer',
            label: 'Prefer not to answer',
          },
        ],
      },
    },
    {
      id: '18',
      type: 'dropdown_options',
      attributes: {
        id: 18,
        key: 'born_as',
        value: [
          {
            key: 'Male',
            label: 'Male',
          },
          {
            key: 'Female',
            label: 'Female',
          },
          {
            key: 'Intersex',
            label: 'Intersex',
          },
        ],
      },
    },
    {
      id: '19',
      type: 'dropdown_options',
      attributes: {
        id: 19,
        key: 'patient_sex_partners',
        value: [
          {
            key: 'Male',
            label: 'Male',
          },
          {
            key: 'Female',
            label: 'Female',
          },
          {
            key: 'Transgender',
            label: 'Transgender',
          },
        ],
      },
    },
    {
      id: '20',
      type: 'dropdown_options',
      attributes: {
        id: 20,
        key: 'patient_sex_type',
        value: [
          {
            key: 'Anal Bottom',
            label: 'Anal Bottom',
          },
          {
            key: 'Anal Top',
            label: 'Anal Top',
          },
          {
            key: 'Oral',
            label: 'Oral',
          },
          {
            key: 'Vaginal',
            label: 'Vaginal',
          },
          {
            key: 'No Answer',
            label: 'No Answer',
          },
        ],
      },
    },
    {
      id: '21',
      type: 'dropdown_options',
      attributes: {
        id: 21,
        key: 'patient_sex_amount',
        value: [
          {
            key: '0',
            label: '0',
          },
          {
            key: '1-5',
            label: '1-5',
          },
          {
            key: '5-10',
            label: '5-10',
          },
          {
            key: '10+',
            label: '10+',
          },
          {
            key: 'Unknown',
            label: 'Unknown',
          },
        ],
      },
    },
    {
      id: '22',
      type: 'dropdown_options',
      attributes: {
        id: 22,
        key: 'patient_had_diseases',
        value: [
          {
            key: 'HepatitisB',
            label: 'HepatitisB',
          },
          {
            key: 'HepatitisC',
            label: 'HepatitisC',
          },
          {
            key: 'Kidney Disease',
            label: 'Kidney Disease',
          },
          {
            key: 'Diabetes',
            label: 'Diabetes',
          },
          {
            key: 'Liver Disease',
            label: 'Liver Disease',
          },
          {
            key: 'None',
            label: 'None',
          },
        ],
      },
    },
    {
      id: '23',
      type: 'dropdown_options',
      attributes: {
        id: 23,
        key: 'patient_had_std',
        value: [
          {
            key: 'Chlamydia',
            label: 'Chlamydia',
          },
          {
            key: 'Gonorrhea',
            label: 'Gonorrhea',
          },
          {
            key: 'Both',
            label: 'Both',
          },
          {
            key: 'None',
            label: 'None',
          },
        ],
      },
    },
    {
      id: '24',
      type: 'dropdown_options',
      attributes: {
        id: 24,
        key: 'timezones',
        value: [
          {
            key: 'Alaska',
            label: 'Alaska',
          },
          {
            key: 'America/Adak',
            label: 'America/Adak',
          },
          {
            key: 'America/Anchorage',
            label: 'America/Anchorage',
          },
          {
            key: 'America/Boise',
            label: 'America/Boise',
          },
          {
            key: 'America/Detroit',
            label: 'America/Detroit',
          },
          {
            key: 'America/Indiana/Knox',
            label: 'America/Indiana/Knox',
          },
          {
            key: 'America/Indiana/Marengo',
            label: 'America/Indiana/Marengo',
          },
          {
            key: 'America/Indiana/Petersburg',
            label: 'America/Indiana/Petersburg',
          },
          {
            key: 'America/Indiana/Tell_City',
            label: 'America/Indiana/Tell_City',
          },
          {
            key: 'America/Indiana/Vevay',
            label: 'America/Indiana/Vevay',
          },
          {
            key: 'America/Indiana/Vincennes',
            label: 'America/Indiana/Vincennes',
          },
          {
            key: 'America/Indiana/Winamac',
            label: 'America/Indiana/Winamac',
          },
          {
            key: 'America/Kentucky/Louisville',
            label: 'America/Kentucky/Louisville',
          },
          {
            key: 'America/Kentucky/Monticello',
            label: 'America/Kentucky/Monticello',
          },
          {
            key: 'America/Menominee',
            label: 'America/Menominee',
          },
          {
            key: 'America/Metlakatla',
            label: 'America/Metlakatla',
          },
          {
            key: 'America/Nome',
            label: 'America/Nome',
          },
          {
            key: 'America/North_Dakota/Beulah',
            label: 'America/North_Dakota/Beulah',
          },
          {
            key: 'America/North_Dakota/Center',
            label: 'America/North_Dakota/Center',
          },
          {
            key: 'America/North_Dakota/New_Salem',
            label: 'America/North_Dakota/New_Salem',
          },
          {
            key: 'America/Sitka',
            label: 'America/Sitka',
          },
          {
            key: 'America/Yakutat',
            label: 'America/Yakutat',
          },
          {
            key: 'Arizona',
            label: 'Arizona',
          },
          {
            key: 'Central Time (US \u0026 Canada)',
            label: 'Central Time (US \u0026 Canada)',
          },
          {
            key: 'Eastern Time (US \u0026 Canada)',
            label: 'Eastern Time (US \u0026 Canada)',
          },
          {
            key: 'Hawaii',
            label: 'Hawaii',
          },
          {
            key: 'Indiana (East)',
            label: 'Indiana (East)',
          },
          {
            key: 'Mountain Time (US \u0026 Canada)',
            label: 'Mountain Time (US \u0026 Canada)',
          },
          {
            key: 'Pacific Time (US \u0026 Canada)',
            label: 'Pacific Time (US \u0026 Canada)',
          },
        ],
      },
    },
    {
      id: '25',
      type: 'dropdown_options',
      attributes: {
        id: 25,
        key: 'encounter_types',
        value: {
          'Hep C': 4,
          'HIV Adherence': 8,
          'HIV Enrollment': 5,
          'HIV Follow Up': 7,
          'HIV Initial': 6,
          'Injectable PrEP': 10,
          PEP: 11,
          'PrEP Follow Up': 3,
          'PrEP Initial': 1,
          'PrEP Quarterly': 2,
          'STI Follow Up': 9,
          'STI Testing': 12,
          'Weight Loss': 14,
          Wellness: 13,
        },
      },
    },
    {
      id: '26',
      type: 'dropdown_options',
      attributes: {
        id: 26,
        key: 'provider_types',
        value: [
          [1, 'PrEP'],
          [2, 'Hep C'],
          [3, 'HIV'],
          [4, 'STI-PEP'],
          [5, 'STI'],
          [6, 'Injectable PrEP'],
          [7, 'PEP'],
          [8, 'STI Testing'],
          [9, 'Wellness'],
          [10, 'Weight Loss'],
        ],
      },
    },
    {
      id: '27',
      type: 'dropdown_options',
      attributes: {
        id: 27,
        key: 'service_lines',
        value: [
          [1, 'PrEP'],
          [2, 'Hep C'],
          [3, 'HIV'],
          [5, 'STI'],
          [6, 'Injectable PrEP'],
          [7, 'PEP'],
          [8, 'STI Testing'],
          [9, 'Wellness'],
          [10, 'Weight Loss'],
        ],
      },
    },
    {
      id: '28',
      type: 'dropdown_options',
      attributes: {
        id: 28,
        key: 'patient_event_categories',
        value: [
          {
            kind: 'voice',
            label: 'Voice Call',
          },
          {
            kind: 'opt-in',
            label: 'Opt-in',
          },
          {
            kind: 'consent',
            label: 'Consent',
          },
          {
            kind: 'update',
            label: 'Update',
          },
          {
            kind: 'ma-task',
            label: 'MA Task',
          },
          {
            kind: 'cs-task',
            label: 'Support Task',
          },
          {
            kind: 'p-task',
            label: 'Provider Task',
          },
          {
            kind: 'ph-task',
            label: 'Pharmacy Task',
          },
          {
            kind: 'treatment-type',
            label: 'Treatment Type',
          },
          {
            kind: 'customer-support',
            label: 'Customer Support',
          },
          {
            kind: 'patient-assistance',
            label: 'Patient Assistance',
          },
          {
            kind: 'break-glass',
            label: 'Break Glass',
          },
          {
            kind: 'merge',
            label: 'Merge',
          },
          {
            kind: 'download',
            label: 'Download',
          },
          {
            kind: 'fax',
            label: 'Fax',
          },
        ],
      },
    },
    {
      id: '29',
      type: 'dropdown_options',
      attributes: {
        id: 29,
        key: 'lab_review_statuses',
        value: [
          ['Needs Follow-up', 'Needs Follow-up'],
          ['Needs Review', 'Needs Review'],
          ['Nurse Reviewed', 'Nurse Reviewed'],
          ['Ready for Patient', 'Ready'],
          ['Released', 'Released'],
          ['Reviewing', 'Reviewing'],
        ],
      },
    },
    {
      id: '30',
      type: 'dropdown_options',
      attributes: {
        id: 30,
        key: 'allergy_severities',
        value: ['intolerance', 'mild', 'moderate', 'not_sure', 'severe'],
      },
    },
    {
      id: '31',
      type: 'dropdown_options',
      attributes: {
        id: 31,
        key: 'vitals',
        value: {
          pulse_oximetry: '%',
          heart_rate: 'bpm',
          temperature: 'F',
          height: 'in',
          weight: 'lb',
          blood_glucose: 'mg/dL',
          bp: 'mmHg',
        },
      },
    },
    {
      id: '32',
      type: 'dropdown_options',
      attributes: {
        id: 32,
        key: 'lab_vitals',
        value: [
          {
            value: 'rpr',
            label: 'RPR',
            unit: '',
          },
          {
            value: 'gfr',
            label: 'GFR',
            unit: '',
          },
          {
            value: 'creatinine',
            label: 'Creatinine',
            unit: 'mg/dL',
          },
          {
            value: 'viral_load',
            label: 'Viral Load',
            unit: 'copies/mL',
          },
          {
            value: 'cd4',
            label: 'CD4',
            unit: 'cells/uL',
          },
          {
            value: 'phq',
            label: 'PHQ',
            unit: '',
          },
        ],
      },
    },
    {
      id: '33',
      type: 'dropdown_options',
      attributes: {
        id: 33,
        key: 'lab_statuses',
        value: [
          'Cancelled',
          'Delivered To Patient',
          'Failed Delivery To Patient',
          'In Transit to Lab',
          'In Transit to Patient',
          'Lab Issue',
          'Lab Processing',
          'Lab Rejected',
          'Needs Follow-up',
          'Needs Review',
          'Nurse Reviewed',
          'Order Failed',
          'Ordered',
          'Pending',
          'Ready',
          'Received by Lab',
          'Released',
          'Requested',
          'Returned to Lab',
          'Reviewing',
          'Shipment Pending',
          'Shipped',
          'Unmatched',
        ],
      },
    },
    {
      id: '34',
      type: 'dropdown_options',
      attributes: {
        id: 34,
        key: 'rx_statuses_for_pharmacy',
        value: [
          ['Delivered', 'delivered'],
          ['Fill Scheduled', 'Fill Scheduled'],
          ['Filled at Other Pharmacy', 'Filled at Other Pharmacy'],
          ['Need Insurance Info', 'Need Insurance Info'],
          ['Need to Transfer Rx', 'Need to Transfer Rx'],
          ['On hold', 'On hold'],
          ['Patient Assistance Pending', 'Patient Assistance Pending'],
          ['Patient Calls in Progress', 'Patient Calls in Progress'],
          ['Pharmacy Follow-up', 'Pharmacy Follow-up'],
          ['Prior Authorization Required', 'Prior Authorization Required'],
          ['Rx Clarification Needed', 'Rx Clarification Needed'],
          ['Unable to reach patient', 'Unable to reach patient'],
          ['Uninsured', 'Uninsured'],
        ],
      },
    },
    {
      id: '35',
      type: 'dropdown_options',
      attributes: {
        id: 35,
        key: 'prior_auth_templates',
        value: ['Adherence', 'Bone Risk', 'Custom', 'General', 'GLP1', 'Lactose', 'Low GFR', 'Renal Risk', 'TDF Intolerance'],
      },
    },
    {
      id: '36',
      type: 'dropdown_options',
      attributes: {
        id: 36,
        key: 'soap_lab_results_positive_for_sti',
        value: ['Chlamydia', 'Gonorrhea', 'Hepatitis B', 'Hepatitis C', 'HIV', 'Syphilis'],
      },
    },
    {
      id: '37',
      type: 'dropdown_options',
      attributes: {
        id: 37,
        key: 'assessment_types',
        value: [
          {
            value: 'pep',
            label: 'PEP Health Assessment',
          },
          {
            value: 'quarterly_lab',
            label: 'Quarterly Renewal Health Assessment',
          },
          {
            value: 'sti',
            label: 'STI Health Assessment',
          },
          {
            value: 'prep_post_encounter',
            label: 'PrEP Initial Post Encounter Med Assessment',
          },
          {
            value: 'hiv',
            label: 'HIV Health Assessment',
          },
        ],
      },
    },
    {
      id: '38',
      type: 'dropdown_options',
      attributes: {
        id: 38,
        key: 'reach_la_team_members',
        value: [
          {
            key: 'Troy Lucas',
            label: 'Troy Lucas',
          },
          {
            key: 'Prince Gray',
            label: 'Prince Gray',
          },
          {
            key: 'Eric Lewis (E Jay)',
            label: 'Eric Lewis (E Jay)',
          },
          {
            key: 'Josue Rosas (Bunni)',
            label: 'Josue Rosas (Bunni)',
          },
          {
            key: 'Anthony Giron',
            label: 'Anthony Giron',
          },
          {
            key: 'Other',
            label: 'Other',
          },
        ],
      },
    },
    {
      id: '39',
      type: 'dropdown_options',
      attributes: {
        id: 39,
        key: 'expire_ga_reasons',
        value: [
          'Changed CBO/Address',
          'Incorrect Information on Application',
          'Medication Incorrect',
          'Newly Insured',
          'Patient Unresponsive',
          'Provider Assignment Changed',
        ],
      },
    },
    {
      id: '40',
      type: 'dropdown_options',
      attributes: {
        id: 40,
        key: 'languages',
        value: [
          {
            key: 'American Sign Language',
            label: 'American Sign Language',
          },
          {
            key: 'Arabic',
            label: 'Arabic',
          },
          {
            key: 'Cantonese',
            label: 'Cantonese',
          },
          {
            key: 'English',
            label: 'English',
          },
          {
            key: 'Haitian',
            label: 'Haitian',
          },
          {
            key: 'Korean',
            label: 'Korean',
          },
          {
            key: 'Mandarin',
            label: 'Mandarin',
          },
          {
            key: 'Portuguese',
            label: 'Portuguese',
          },
          {
            key: 'Spanish',
            label: 'Spanish',
          },
          {
            key: 'Tagalog',
            label: 'Tagalog',
          },
          {
            key: 'Vietnamese',
            label: 'Vietnamese',
          },
          {
            key: 'Other',
            label: 'Other',
          },
        ],
      },
    },
    {
      id: '41',
      type: 'dropdown_options',
      attributes: {
        id: 41,
        key: 'patient_sexualities',
        value: [
          {
            key: 'Gay',
            label: 'Gay',
          },
          {
            key: 'Straight',
            label: 'Straight',
          },
          {
            key: 'Bisexual',
            label: 'Bisexual',
          },
          {
            key: 'Pansexual',
            label: 'Pansexual',
          },
          {
            key: 'Other',
            label: 'Other',
          },
          {
            key: 'Queer',
            label: 'Queer',
          },
          {
            key: 'No Answer',
            label: 'No Answer',
          },
        ],
      },
    },
    {
      id: '42',
      type: 'dropdown_options',
      attributes: {
        id: 42,
        key: 'provider_statuses',
        value: [
          'Clinical development strategist',
          'CPA \u0026 Patients',
          'CPA only',
          'External',
          'Full time',
          'Part time',
          'Per diem',
          'Reduced full time',
        ],
      },
    },
    {
      id: '43',
      type: 'dropdown_options',
      attributes: {
        id: 43,
        key: 'soap_reasons_for_medications',
        value: [
          'Adherence issues',
          'Concerns regarding side effects of alternatives',
          'Continuation of current therapy',
          'Contraindicated Truvada due to eGFR',
          'Costs concerns',
          'Drug interaction precluding use of Descovy',
          'Drug interaction precluding use of Truvada or generic',
          'Elevated risk of bone density loss',
          'Elevated risk of renal disease',
          'Insurance mandate',
          'Lactose intolerance',
          'Medical condition precluding use of Descovy',
          'Medical condition precluding use of Truvada or generic',
          'Past trial of Descovy with patient intolerance',
          'Past trial of Truvada with patient intolerance',
          'Patient born female',
          'Patient preference',
          'Patient requests 2-1-1 or on-demand PrEP dosing',
          'Pill size intolerance',
          'Provider Recommended',
          'Requires Gilead Advancing Access',
          'Tobacco Use',
          'Urgent need for nPEP',
        ],
      },
    },
    {
      id: '44',
      type: 'dropdown_options',
      attributes: {
        id: 44,
        key: 'sop_categories',
        value: ['CBO', 'Customer Service', 'Hep C', 'Lab', 'LHC', 'Medical Assistant', 'PrEP', 'Provider', 'Release Notes', 'STI'],
      },
    },
    {
      id: '45',
      type: 'dropdown_options',
      attributes: {
        id: 45,
        key: 'sop_policies',
        value: ['Clinical', 'Operational', 'Support'],
      },
    },
    {
      id: '46',
      type: 'dropdown_options',
      attributes: {
        id: 46,
        key: 'task_expired_reasons',
        value: [
          'Duplicate task',
          'Patient has already provided insurance to the pharmacy',
          'Patient is inactive',
          'Patient uninsured ; CBO not accepting',
          'Patient unresponsive',
          'Patient will continue with transfer pharmacy',
          'Patient will resume with partner pharmacy next month',
          'Script has already been filled',
          'Task has already been completed',
        ],
      },
    },
    {
      id: '72',
      type: 'dropdown_options',
      attributes: {
        id: 72,
        key: 'provider_task_expired_reasons',
        value: [
          'Duplicate task',
          'Insurance has lapsed',
          'Patient has not had labs drawn from prior encounter',
          'Patient provided outside labs',
          'Task has already been completed',
        ],
      },
    },
    {
      id: '47',
      type: 'dropdown_options',
      attributes: {
        id: 47,
        key: 'prescription_statuses',
        value: [
          'Deleted',
          'Delivered',
          'Fill Scheduled',
          'Immediate Access',
          'Need Insurance Info',
          'Need to Transfer Rx',
          'On Hold',
          'Patient Assistance Pending',
          'Patient Calls in Progress',
          'Pending',
          'Prior Authorization Required',
          'Refills Needed',
          'Refills Remaining',
          'Requested',
          'Rx Clarification Needed',
          'Sent to pharmacy',
          'Shipped',
          'Transferred',
          'Unable to reach patient',
          'With errors',
        ],
      },
    },
    {
      id: '48',
      type: 'dropdown_options',
      attributes: {
        id: 48,
        key: 'roi_medical_records_entities',
        value: ['encounters', 'health_history', 'labs', 'prescriptions', 'profile_notes'],
      },
    },
    {
      id: '49',
      type: 'dropdown_options',
      attributes: {
        id: 49,
        key: 'lab_vendors',
        value: [
          [1, 'MTL'],
          [2, 'Quest'],
          [3, 'GMHC'],
          [4, 'Ash'],
          [5, 'Manual'],
          [6, 'HIV Self Test'],
        ],
      },
    },
    {
      id: '50',
      type: 'dropdown_options',
      attributes: {
        id: 50,
        key: 'doh_morbidity_syphilis_stage',
        value: [
          {
            value: 'primary',
            label: 'Primary',
          },
          {
            value: 'secondary',
            label: 'Secondary',
          },
          {
            value: 'early_latent',
            label: 'Early Latent (\u003c1 year)',
          },
          {
            value: 'late_latent',
            label: 'Late Latent (\u003e1 year)',
          },
          {
            value: 'latent',
            label: 'Latent (duration unknown)',
          },
        ],
      },
    },
    {
      id: '51',
      type: 'dropdown_options',
      attributes: {
        id: 51,
        key: 'doh_morbidity_symptoms_signs',
        value: [
          {
            value: 'lesion',
            label: 'Lesion (Ulcer)',
          },
          {
            value: 'rash',
            label: 'Rash',
          },
          {
            value: 'no_symptoms',
            label: 'No symptoms',
          },
          {
            value: 'unknown',
            label: 'Unknown',
          },
          {
            value: 'other',
            label: 'Other',
          },
        ],
      },
    },
    {
      id: '52',
      type: 'dropdown_options',
      attributes: {
        id: 52,
        key: 'ma_tasks',
        value: [
          {
            kind: 'Prior Auth',
            label: 'Prior Auth',
          },
          {
            kind: 'STI Report',
            label: 'STI Report',
          },
          {
            kind: 'RX Fill issue',
            label: 'Rx Fills',
          },
          {
            kind: 'Lab returns',
            label: 'Lab returns',
          },
          {
            kind: 'Lab Rejected',
            label: 'Lab Rejected',
          },
          {
            kind: 'Lab Failed',
            label: 'Lab Failed',
          },
          {
            kind: 'ROI PDF',
            label: 'ROI PDF',
          },
          {
            kind: 'Appeals',
            label: 'Appeals',
          },
          {
            kind: 'Syphilis Task',
            label: 'Syphilis Task',
          },
          {
            kind: 'Qlink Lab',
            label: 'Qlink Lab',
          },
          {
            kind: 'MA - Fax',
            label: 'Fax',
          },
          {
            kind: 'MA - VM',
            label: 'VM',
          },
          {
            kind: 'DOH Reporting',
            label: 'DOH Reporting',
          },
          {
            kind: 'Alert CBO',
            label: 'Alert CBO',
          },
          {
            kind: 'Linkage to Care',
            label: 'Linkage to Care',
          },
          {
            kind: 'Qlink Result',
            label: 'Qlink Result',
          },
          {
            kind: 'Quest Bill',
            label: 'Quest Bill',
          },
          {
            kind: 'Lab Review',
            label: 'Lab Review',
          },
        ],
      },
    },
    {
      id: '53',
      type: 'dropdown_options',
      attributes: {
        id: 53,
        key: 'cs_tasks',
        value: [
          {
            kind: 'Financial Assistance',
            label: 'Financial',
          },
          {
            kind: 'Contact Issue',
            label: 'Contact',
          },
          {
            kind: 'Insurance Exception',
            label: 'Insurance',
          },
          {
            kind: 'Address Change',
            label: 'Address',
          },
          {
            kind: 'IT Issue',
            label: 'IT',
          },
          {
            kind: 'Reschedule Appointment',
            label: 'Appt',
          },
          {
            kind: 'Rx Transfer',
            label: 'Rx Xfer',
          },
          {
            kind: 'Gilead AA Application CS',
            label: 'Gilead',
          },
          {
            kind: 'Re-engage',
            label: 'Re-engage',
          },
          {
            kind: 'Immediate Access',
            label: 'Immediate Access',
          },
          {
            kind: 'Fax',
            label: 'Fax',
          },
          {
            kind: 'VM',
            label: 'VM',
          },
          {
            kind: 'Email',
            label: 'Email',
          },
          {
            kind: 'Self Pay Fail',
            label: 'Self Pay Fail',
          },
        ],
      },
    },
    {
      id: '54',
      type: 'dropdown_options',
      attributes: {
        id: 54,
        key: 'without_patient_tasks',
        value: [
          {
            kind: 'VM',
            label: 'VM',
          },
          {
            kind: 'MA - VM',
            label: 'VM',
          },
          {
            kind: 'MA - Fax',
            label: 'Fax',
          },
          {
            kind: 'Email',
            label: 'Email',
          },
        ],
      },
    },
    {
      id: '55',
      type: 'dropdown_options',
      attributes: {
        id: 55,
        key: 'lhc_tasks',
        value: [
          {
            kind: 'DOH Reporting',
            label: 'DOH Reporting',
          },
          {
            kind: 'Alert CBO',
            label: 'Alert CBO',
          },
          {
            kind: 'Linkage to Care',
            label: 'Linkage to Care',
          },
          {
            kind: 'Qlink Result',
            label: 'Qlink Result',
          },
          {
            kind: 'Quest Bill',
            label: 'Quest Bill',
          },
        ],
      },
    },
    {
      id: '56',
      type: 'dropdown_options',
      attributes: {
        id: 56,
        key: 'tasks_prevent_manual_creation',
        value: [
          {
            kind: 'Gilead AA Application',
            label: 'Gilead AA Application',
          },
          {
            kind: 'Incomplete Labs',
            label: 'Incomplete Labs',
          },
          {
            kind: 'Rx Clarification',
            label: 'Rx Clarification',
          },
          {
            kind: 'Pending Quest Order',
            label: 'Pending Quest Order',
          },
          {
            kind: 'Patient At Risk',
            label: 'Patient At Risk',
          },
          {
            kind: 'PEP Patient At Risk',
            label: 'PEP Patient At Risk',
          },
          {
            kind: 'HIV Patient At Risk',
            label: 'HIV Patient At Risk',
          },
          {
            kind: 'GLP1 Patient At Risk',
            label: 'GLP1 Patient At Risk',
          },
          {
            kind: 'TOC',
            label: 'TOC',
          },
        ],
      },
    },
    {
      id: '57',
      type: 'dropdown_options',
      attributes: {
        id: 57,
        key: 'provider_tasks_for_ma',
        value: [
          {
            kind: 'Syphilis Task',
            label: 'Syphilis Task',
          },
          {
            kind: 'Qlink Lab',
            label: 'Qlink Lab',
          },
        ],
      },
    },
    {
      id: '58',
      type: 'dropdown_options',
      attributes: {
        id: 58,
        key: 'provider_tasks',
        value: [
          {
            kind: 'ABNL Lab Follow Up',
            label: 'ABNL Lab Follow Up',
          },
          {
            kind: 'Gilead AA Application',
            label: 'Gilead AA Application',
          },
          {
            kind: 'Incomplete Labs',
            label: 'Incomplete Labs',
          },
          {
            kind: 'Rx Clarification',
            label: 'Rx Clarification',
          },
          {
            kind: 'Pending Quest Order',
            label: 'Pending Quest Order',
          },
          {
            kind: 'TOC',
            label: 'TOC',
          },
          {
            kind: 'Provider Reminder',
            label: 'Provider Reminder',
          },
        ],
      },
    },
    {
      id: '59',
      type: 'dropdown_options',
      attributes: {
        id: 59,
        key: 'par_tasks',
        value: [
          {
            kind: 'Patient At Risk',
            label: 'Patient At Risk',
          },
          {
            kind: 'PEP Patient At Risk',
            label: 'PEP Patient At Risk',
          },
          {
            kind: 'HIV Patient At Risk',
            label: 'HIV Patient At Risk',
          },
          {
            kind: 'GLP1 Patient At Risk',
            label: 'GLP1 Patient At Risk',
          },
        ],
      },
    },
    {
      id: '60',
      type: 'dropdown_options',
      attributes: {
        id: 60,
        key: 'pharmacy_tasks',
        value: [
          {
            kind: 'Prior Auth',
            label: 'Prior Auth',
          },
          {
            kind: 'Financial Assistance',
            label: 'Financial',
          },
          {
            kind: 'Contact Issue',
            label: 'Contact',
          },
          {
            kind: 'Insurance Exception',
            label: 'Insurance',
          },
          {
            kind: 'Address Change',
            label: 'Address',
          },
          {
            kind: 'Task Comment',
            label: 'Task Comment',
          },
          {
            kind: 'Immediate Access',
            label: 'Immediate Access',
          },
        ],
      },
    },
    {
      id: '61',
      type: 'dropdown_options',
      attributes: {
        id: 61,
        key: 'rx_required_tasks',
        value: [
          {
            kind: 'Prior Auth',
            label: 'Prior Auth',
          },
          {
            kind: 'Financial Assistance',
            label: 'Financial',
          },
          {
            kind: 'Insurance Exception',
            label: 'Insurance',
          },
          {
            kind: 'Rx Transfer',
            label: 'Rx Xfer',
          },
        ],
      },
    },
    {
      id: '62',
      type: 'dropdown_options',
      attributes: {
        id: 62,
        key: 'prior_auth_done_reasons',
        value: ['Approved', 'Denied', 'Denied - appealed', 'Duplicate Request', 'PA Not Needed', 'Unable to submit'],
      },
    },
    {
      id: '63',
      type: 'dropdown_options',
      attributes: {
        id: 63,
        key: 'reasons_pending_quest_order',
        value: ['Placed lab order in Quest', 'Unable to place lab order in Quest'],
      },
    },
    {
      id: '64',
      type: 'dropdown_options',
      attributes: {
        id: 64,
        key: 'par_done_reasons',
        value: [
          'No new flow sent - Other',
          'No new flow sent - Patient already received a new q flow',
          'No new flow sent - Patient not responsive',
          'No new flow sent - Patient taking a PrEP break',
          'Sent new QHA',
          'Sent new quarterly flow',
        ],
      },
    },
    {
      id: '65',
      type: 'dropdown_options',
      attributes: {
        id: 65,
        key: 'pep_par_done_reasons',
        value: [
          'Messaged patient outreach - no response',
          'Other reason',
          'Patient declined in error, PrEP start indicated',
          'Patient declines PEP to PrEP start',
          'Patient seeking local care for PrEP',
        ],
      },
    },
    {
      id: '66',
      type: 'dropdown_options',
      attributes: {
        id: 66,
        key: 'hiv_par_done_reasons',
        value: [
          'Messaged patient outreach - no response',
          'Other reason',
          'Patient declined in error, HIV care restarted',
          'Patient declines to continue HIV care',
          'Patient seeking local care for HIV care',
        ],
      },
    },
    {
      id: '67',
      type: 'dropdown_options',
      attributes: {
        id: 67,
        key: 'lab_follow_up_task_resolve_reasons',
        value: ['No STI, Plan documented, task resolved', 'Patient not responsive', 'STI Encounter note completed'],
      },
    },
    {
      id: '68',
      type: 'dropdown_options',
      attributes: {
        id: 68,
        key: 'gilead_done_reasons',
        value: ['Approved', 'Denied - active insurance', 'Denied - Medicaid', 'Denied - other', 'Denied - over income'],
      },
    },
    {
      id: '69',
      type: 'dropdown_options',
      attributes: {
        id: 69,
        key: 'appeal_done_reasons',
        value: ['Appeal - approved', 'Appeal - denied', 'Duplicate Request', 'PA Not Needed', 'Unable to submit'],
      },
    },
    {
      id: '70',
      type: 'dropdown_options',
      attributes: {
        id: 70,
        key: 'immediate_access_reasons',
        value: ['Approved', 'Denied - active insurance', 'Denied - Medicaid', 'Denied - Other reason', 'Denied - over income'],
      },
    },
    {
      id: '71',
      type: 'dropdown_options',
      attributes: {
        id: 71,
        key: 'task_qlink_quest_panels',
        value: [
          '10165 - Basic metabolic panel',
          '10231 - CMP',
          '10256 - Hepatic function panel',
          '11363 - CT/GC RNA,TMA,UROGEN',
          '13646 - TPPA IA only',
          '16868 - Genotype, HIV Resistance (INSTI)',
          '17569 - PSA, Total with reflex to Free',
          '19550 - Trichomonias, NAAT',
          '19774 - HLAB5701',
          '30741 - Testosterone, Free and Total',
          '34949 - Genotype, HIV Resistance (RTI, PI)',
          '35645 - Hepatitis C RNA PCR',
          '36970 - Quantiferon Gold',
          '375 - CREATININE',
          '40085 - HIV RNA Quant',
          '496 - Hemoglobin A1c',
          '498 - HEP B sAG reflex to DNA',
          '508 - Hepatitis A Titer',
          '5259 - MMR Antibodies',
          '6399 - CBC with diff.',
          '6462 - Hepatitis Panel ABC (full)',
          '6517 - Urine Albumin with Creatinine',
          '7048 - Urinalysis, Screen',
          '7105 - Hepatitis B panel',
          '7600 - Lipid Panel, Standard',
          '8360 - CD4 lymphocyte panel 5',
          '8396 - Serum HCG',
          '8472 - Hepatitis C Antibody with reflex to viral load',
          '90349 - EIA-RPR-TPPA CASCADE',
          '91431 - HIV1/2 AG/AB,4 W/RFL',
          '91475 - Mycoplasma genitalium, NAAT',
          '94807 - Genosure pro viral DNA (archive)',
          'Qcare_Creatinine - Creatinine',
        ],
      },
    },
    {
      id: '72',
      type: 'dropdown_options',
      attributes: {
        id: 72,
        key: 'glp1_par_done_reasons',
        value: [
          'Resolved - new GLP1 assessment sent',
          'Resolved - GLP1 medication delivery in progress',
          'Resolved - patient no longer interested in GLPs',
          'Resolved - Other',
        ],
      },
    },
  ],
  jsonapi: {
    version: '1.0',
  },
}
export const allDeserialized = deserialize(all, { transformKeys: 'camelCase' }).data
